<template>
    <div class="focusYouth min-w">
		<div class="youthlearn">
			<youthlearn :list='youthStudy' sign='20'></youthlearn>
		</div>

		<div class="list">
			<div class="l_c">
				<tiplist :title="'青年发展规划'" sign="21" :list='youthPlan'></tiplist>
			</div>
			<div class="r_c">
				<tiplist :title="'青年创业'" sign="103" :list='youthSay'></tiplist>
			</div>
		</div>

	</div>
</template>

<script>
import tiplist from '@/components/helppart/tiplist.vue'
import youthlearn from '@/components/helppart/youthlearn.vue'
export default {
	components:{tiplist,youthlearn},
    data() {
        return {
            youthStudy:[],
			youthPlan:[],
			youthSay:[]
        };
    },

    created() {
        this.init()
    },

    methods: {
		init(){
			this.getYouthStudy();
			this.getYouthPlan();
			this.getYouthSay();
		},
        getYouthStudy(){//青年大学习
            var param={
                pageNo:1,//分页
                pageSize:6,
                msgType:13
            }
            this.$get('/web/information/list',param).then(res=>{
               this.youthStudy=res.result.records;
            })
        },
		getYouthPlan(){//青年发展规划
            var param={
                pageNo:1,//分页
                pageSize:7,
                msgType:14
            }
            this.$get('/web/information/list',param).then(res=>{
               this.youthPlan=res.result.records;
            })
        },
		getYouthSay(){//青年说
            var param={
                pageNo:1,//分页
                pageSize:7,
                msgType:103
            }
            this.$get('/web/information/list',param).then(res=>{
               this.youthSay=res.result.records;
            })
        },
    },
};
</script>

<style lang="scss" scoped>
.focusYouth{
	min-height: 986px;
	position: relative;
	margin: auto;
	height: 100%;
	background: #ffffff;
	padding: 20px 10px 20px 10px;
	.youthlearn{


	}

	.list{
		margin: 40px 0px 0px 20px;
		display: flex;
		.l_c{
			flex: 1;
			margin-right: 10px;
		}
		.r_c{
			flex: 1;
			margin-left: 10px;
		}
	}

}

</style>
